import QRGun from './QRGun';
export default QRGun;